module.exports = __webpack_public_path__ + "media/components/assets/img/flag/no-89e958e42da2730a976c89da35c60fe4.svg";